export function changeLoading(loading) {
	return {
		type: "@billingPlan/CHANGE_LOADING",
		payload: {
			loading,
		},
	};
}

export function changeScroll(onscroll) {
	return {
		type: "@billingPlan/CHANGE_SCROLL",
		payload: {
			onscroll,
		},
	};
}
export function selectedPlanRequest(plan, redirectToResearch = false, id_research = null, cd_promotional = null) {
	return {
		type: "@billingPlan/SELECTED_PLAN_REQUEST",
		payload: {
			plan,
			redirectToResearch,
			id_research,
			cd_promotional,
		},
	};
}

export function selectedPlanSuccess(plan) {
	return {
		type: "@billingPlan/SELECTED_PLAN_SUCCESS",
		payload: {
			plan,
		},
	};
}

export function selectedResearchRequest(research) {
	return {
		type: "@billingPlan/SELECTED_RESEARCH_REQUEST",
		payload: {
			research,
		},
	};
}

export function onGetPlanResearchs(plan, redirectToResearch = false, id_research = null, cd_promotional = null) {
	return {
		type: "@billingPlan/ON_GET_PLAN_RESEARCHS",
		payload: {
			plan,
			redirectToResearch,
			id_research,
			cd_promotional,
		},
	};
}

export function onGetResearchByPlanSuccess(listResearch, planTitle) {
	return {
		type: "@billingPlan/ON_GET_RESEARCH_BY_PLAN_SUCCESS",
		payload: {
			listResearch,
			planTitle,
		},
	};
}

export function selectedResearchSuccess(research) {
	return {
		type: "@billingPlan/SELECTED_RESEARCH_SUCCESS",
		payload: {
			research,
		},
	};
}

export function selectedPlanByIdRequest(id_plan) {
	return {
		type: "@billingPlan/SELECTED_PLAN_BY_ID_REQUEST",
		payload: {
			id_plan,
		},
	};
}

export function validAddressUserRequest() {
	return {
		type: "@billingPlan/VALID_ADDRESS_USER_REQUEST",
		payload: {},
	};
}

export function validAddressUserSuccess(isAddressValid) {
	return {
		type: "@billingPlan/VALID_ADDRESS_USER_SUCCESS",
		payload: {
			isAddressValid,
		},
	};
}

export function onUpdateAddressRequest(address) {
	return {
		type: "@billingPlan/ON_UPDATE_ADDRESS_REQUEST",
		payload: {
			address,
		},
	};
}

export function onUpdateAddressSuccess() {
	return {
		type: "@billingPlan/ON_UPDATE_ADDRESS_SUCCESS",
		payload: {},
	};
}

export function onGetBillingPlansRequest(cd_recurrence, cd_promotional) {
	return {
		type: "@billingPlan/ON_GET_BILLING_PLAN_REQUEST",
		payload: {
			cd_recurrence,
			cd_promotional,
		},
	};
}

export function onGetBillingPlansByCDRequest(cd_plan) {
	return {
		type: "@billingPlan/ON_GET_BILLING_PLAN_BY_CD_REQUEST",
		payload: {
			cd_plan,
		},
	};
}
export function onGetProductByCDRequest(cd_plan) {
	return {
		type: "@billingPlan/ON_GET_PRODUCT_BY_CD_REQUEST",
		payload: {
			cd_plan,
		},
	};
}

export function onGetPaymentModeRequest(id_product) {
	return {
		type: "@billingPlan/ON_GET_PAYMENT_MODE_REQUEST",
		payload: {
			id_product,
		},
	};
}

export function onGetBillingPlansByCDSuccess(plan) {
	return {
		type: "@billingPlan/ON_GET_BILLING_PLAN_BY_CD_SUCCESS",
		payload: {
			plan,
		},
	};
}

export function onGetPaymentModeSuccess(payment_mode) {
	return {
		type: "@billingPlan/ON_GET_PAYMENT_MODE_SUCCESS",
		payload: {
			payment_mode,
		},
	};
}

export function onGetBillingPlansSuccess(listPlan) {
	return {
		type: "@billingPlan/ON_GET_BILLING_PLAN_SUCCESS",
		payload: { listPlan },
	};
}

export function cleanPlanRequest() {
	return {
		type: "@billingPlan/CLEAN_PLAN_REQUEST",
		payload: {},
	};
}

export function cleanPlanSuccess() {
	return {
		type: "@billingPlan/CLEAN_PLAN_SUCCESS",
		payload: {},
	};
}

export function changeCdRecurrenceRequest(cd_recurrence) {
	return {
		type: "@billingPlan/CHANGE_CD_RECURRENCE_REQUEST",
		payload: { cd_recurrence },
	};
}

export function changeCdRecurrenceSuccess(cd_recurrence) {
	return {
		type: "@billingPlan/CHANGE_CD_RECURRENCE_SUCCESS",
		payload: { cd_recurrence },
	};
}

export function getLastActivePlanStatus() {
	return {
		type: "@billingPlan/GET_ACTIVE_PLAN_STATUS",
		payload: {},
	};
}

export function selectedPaymentMode(payment_mode_selected) {
	return {
		type: "@billingPlan/SELECTED_PAYMENT_MODE",
		payload: {
			payment_mode_selected,
		},
	};
}

export function processResultDoPayment(result) {
	return {
		type: "@billingPlan/PROCESS_RESULT_DO_PAYMENT",
		payload: {
			result,
		},
	};
}

export function disableButton(disable_button) {
	return {
		type: "@billingPlan/DISABLE_BUTTON",
		payload: {
			disable_button,
		},
	};
}

export function setParamRoute(data) {
	return {
		type: "@billingPlan/SET_PARAM_ROUTE",
		payload: data,
	};
}

export function setIdResearch(id_research) {
	return {
		type: "@billingPlan/SET_ID_RESEARCH",
		payload: id_research,
	};
}

export function changeQttdInstallments(qtt_installments) {
	return {
		type: "@billingPlan/QTT_INSTALLMENTS",
		payload: { qtt_installments },
	};
}

export function setCdPromotional(cd_promotional) {
	return {
		type: "@billingPlan/SET_CD_PROMOTIONAL",
		payload: { cd_promotional },
	};
}

export function changeInstallmentOptions(installment_options) {
	return {
		type: "@billingPlan/INSTALLMENT_OPTIONS",
		payload: { installment_options },
	};
}

export function getMicroServiceDetailFluxPromo(cdPromotional) {
	return {
		type: "@billingPlan/CALL_MICRO_SERVICE_DETAIL_BY_CD_PROMOTION",
		payload: { cdPromotional },
	};
}

export function getPlanDetailFluxPromo(cdPromotional) {
	return {
		type: "@billingPlan/CALL_PLAN_DETAIL_BY_ID",
		payload: { cdPromotional },
	};
}

export function responseMicroServiceFluxPromo(param) {
	return {
		type: "@billingPlan/RESPONSE_MICRO_SERVICE_FLUX_PROMO",
		payload: { param },
	};
}

export function responsePlanFluxPromo(param) {
	return {
		type: "@billingPlan/RESPONSE_PLAN_FLUX_PROMO",
		payload: { param },
	};
}

export function setFluxPromotional(param) {
	return {
		type: "@billingPlan/SET_FLUX_PROMOTIONAL",
		payload: { param },
	};
}

export function setProductForCheckout(param, product) {
	return {
		type: "@billingPlan/SET_PRODUCT_FOR_CHECKOUT",
		payload: { param, product },
	};
}
